import axios from '@/utils/request.js'

export const getUserOrderList = (params) => { // 用户查询订单列表
  return axios.post('/goods/gas/order/getUserOrderList', params)
}

export const getOrderInfo = (orderId) => { // 用户查询订单详情
  return axios.get(`/goods/gas/order/getOrderInfo/${orderId}`)
}

export const addOrder = (params) => { // 用户新增订单
  return axios.post('/goods/gas/order/addOrder', params)
}
export const getAgentOrderList = (params) => { // 代理商查询订单列表
  return axios.post('/goods/gas/order/getAgentOrderList', params)
}

export const userReceiveGoods = (params) => { // 用户确认收货
  return axios.post('/goods/gas/order/userReceiveGoods', params)
}

export const getCustomerMesslist = (userId) => { // 用户钢瓶信息
  return axios.post(`/goods/bGlmCylinderCurrentStatus/getCustomerMesslist/${userId}`)
}

export const getUserReturnOrderList = (params) => { // 用户返瓶记录
  return axios.post('/goods/gas/returnOrder/getUserReturnOrderList', params)
}

export const returnOrderInfo = (orderId) => { // 用户查询订单详情
  return axios.get(`/goods/gas/returnOrder/getOrderInfo/${orderId}`)
}

export const userReceiveCylinder = (params) => { // 用户返瓶确认
  return axios.post('/goods/gas/returnOrder/userReceiveCylinder', params)
}
